import UserDispatcherUpdateParams from "../../../../../common/services/user/dispatcher/update/user-dispatcher-update-params";
import DispatcherEditFormData from "./types/dispatcher-edit-form-data";

const create = (
  formData: DispatcherEditFormData,
  dispatcherUuid: string,
): UserDispatcherUpdateParams => {
  return {
    alternativePhoneNumber: formData.alternativePhoneNumber,
    dispatcherUuid,
    dispatchUuid: formData.dispatchUuid,
    email: formData.email,
    firstName: formData.firstName,
    lastName: formData.lastName,
    phoneNumber: formData.phoneNumber,
    username: formData.username,
  };
};

const dispatcherUpdateParamsFactory = {
  create,
};

export default dispatcherUpdateParamsFactory;
